import styled from '@emotion/styled'

export const LabelForm = styled.div`
  color: rgba(0, 0, 0, 0.54); 
  font-size: 14px;
`
